import type { ITariffZoneDetails } from '../../../../models/tariff-zone-details.model';
import type IPolygon from '../../../Shared/Map/models/polygon.model';

export default class TariffZoneHelper {
  private static tariffZonePolygonOptions: { [key: number]: { color: string; fillColor: string; fillOpacity: number; weight: number; interactive: boolean } } = {
    3000: { color: '#FFFFFF', fillColor: '#C95F7F', fillOpacity: 0.35, weight: 5, interactive: false },
    3001: { color: '#FFFFFF', fillColor: '#6C912D', fillOpacity: 0.35, weight: 5, interactive: false },
    3002: { color: '#FFFFFF', fillColor: '#418D8C', fillOpacity: 0.35, weight: 5, interactive: false },
  };

  public static mapTariffZoneDetailsToPolygon(tariffZone: ITariffZoneDetails): IPolygon {
    return {
      id: tariffZone.number.toString(),
      latLngs: TariffZoneHelper.mapWktPolygonToCoordinates(tariffZone.wkt),
      options: TariffZoneHelper.tariffZonePolygonOptions[tariffZone.number],
    };
  }

  protected static mapWktPolygonToCoordinates(wkt: string): L.LatLngExpression[] {
    const result: L.LatLngExpression[] = [];

    let tempWkt = wkt.replace('POLYGON ((', '');
    tempWkt = tempWkt.replace('))', '');

    tempWkt.split(',').forEach((latitudeAndLongitude: string) => {
      result.push(
        latitudeAndLongitude
          .trim()
          .split(' ')
          .reverse()
          .map((coordinate) => parseFloat(coordinate)) as L.LatLngExpression
      );
    });

    return result;
  }
}
